module.exports = __webpack_public_path__ + "img/photo-0029.ddcf3402.jpg";